<template>
  <div class="production_wrap">
    <div class="production_img">
      <div class="img_desc"></div>
    </div>
    <News></News>
    <CallMe />
    <MobileCallme />
  </div>
</template>

<script>
import CallMe from '@/components/callme/index'
import MobileCallme from '@/components/callme/MobileCallme.vue'
import News from './News.vue';

export default {
  data() {
    return {
      procardList: [
        {
          tit: '产业链数据中心',
        },
        {
          tit: '产业链监测',
        },
        {
          tit: '产业评价',
        },
        {
          tit: '产业地图',
        },
        {
          tit: '智能招商系统及服务',
        },
      ],
      procardList2: [
        {
          tit: '智达康选址',
        },
        {
          tit: '产业链监测',
        },
      ],

      activeIndex: 0,
      areaIndex: 0,
      areaList: [
        {
          name: '成都',
          en: 'chengdu',
        },
        {
          name: '德阳',
          en: 'deyang',
        },
        {
          name: '遂宁',
          en: 'suining',
        },
        {
          name: '宜宾',
          en: 'yibin',
        }
      ]
    }
  },

  methods: {
    changeOptionIndex(index) {
      this.activeIndex = index
    },
  },

  components: {
    CallMe,
    MobileCallme,
    News
  },
}
</script>

<style lang="scss" scoped>
.production_wrap {
  width: 100%;
  background-color: #fff;

  .production_img {
    width: 100%;
    height: 600px;
    @media screen and (max-width: 768px) {
      height: 50vw;
    }
    background: url('../../assets/img/cover.jpg') 0 0 no-repeat;
    background-size: 100% 100%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    position: relative;
    .img_tit {
      font-size: 60px;
      font-weight: bold;
      @media screen and (max-width: 768px) {
        font-size: 1.2rem;
      }
    }
    .img_desc {
      font-size: 32px;
      margin-top: 20px;
      @media screen and (max-width: 768px) {
        font-size: 0.85rem;
      }
    }
    .img_btn {
      width: 180px;
      height: 50px;
      border: solid 1px rgb(255, 166, 0);
      background: rgba(25, 166, 0, 0.1);
      color: orange;
      position: absolute;
      bottom: 15%;
      border-radius: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      cursor: pointer;
      transition: all 0.5s;
      &:hover {
        color: #fff;
        background: orange;
      }
      @media screen and (max-width: 768px) {
        width: 80px;
        height: 30px;
        font-size: 14px;
      }
    }
  }

  .area_info_btn {
    width: 80vw;
    margin: 4.6rem auto 0rem;

    .area_btns {
      display: flex;
      margin-bottom: 1.6rem;
      gap: 0 0.8rem;
    }

    .area-btn {
      border-radius: 0.5rem;
      font-size: 1.4rem;
      border: none;
      width: 6.2rem;
      line-height: 3.2rem;
      color: #000;
      border: solid 0.01rem transparent;
      background-color: transparent;
    }

    .active_area_btn {
      border: solid 0.01rem #ff7000;
      color: #ff7000;
    }
  }

  .area_info {
    width: 100%;
    margin-top: 50px;

    .production_inner {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .inner_center {
        display: flex;
        font-size: 2.5rem;
        color: #ff7000;
        font-weight: bold;
        align-items: center;
        margin-bottom: 2rem;

        img {
          margin-right: 1rem;
        }
      }
    }
  }

  p {
    text-align: center;
    color: #3b3b3b;
    font-weight: bold;
    font-size: 20px;
    line-height: 100px;
    @media screen and (max-width: 768px) {
      font-size: 0.9rem;
      padding: 15px 0;
    }
  }

  .area_title {
    width: 80vw;
    text-align: center;
    border-bottom: 1px solid #bfbfbf;
    font-size: 2.2rem;
    padding-bottom: 1.6rem;
    margin: 2rem auto 2rem;
    position: relative;

    &:after { 
      content: '';
      display: block;
      width: 6vw;
      height: 0.5rem;
      background-color: #ff7000;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -0.5rem;
    }
  }

  .advantage_out_wrap {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .carousel_pro {
    width: 60%;
    margin: 60px auto;
    .carousel_pro_item {
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
  .product_shows_wrap {
    width: 100%;
    background: url('../../assets/img/witness-bgc369221.png') 0 0 no-repeat;
    background-size: cover;
    padding: 10px 0 50px 0;
    margin-top: 100px;
    box-sizing: border-box;
    .with_center {
      display: flex;
      justify-content: center;
      .bottom_img_wrap {
        width: 80%;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        @media screen and (max-width: 768px) {
          width: 100%;
        }
        .bottom_img_item {
          width: 30%;
          display: flex;
          flex-wrap: wrap;
          margin-top: 20px;
          margin: 20px;
          h2 {
            color: #3b3b3b;
          }
          @media screen and (max-width: 768px) {
            width: 45%;
          }
          .bottom_img {
            width: 100%;
            position: relative;
            img {
              width: 100%;
            }

            .img_desc {
              position: absolute;
              bottom: 20px;
              width: 100%;
              text-align: center;
              color: #fff;
              font-size: 18px;
              @media screen and (max-width: 768px) {
                font-weight: bold;
                bottom: 8px;
                font-size: 13px;
              }
            }
          }
        }
      }
    }
  }
}
</style>